// import HeaderOnly from "../layout/HeaderOnly";
import Home from "../pages/Home";
import Cars from "../pages/Brands";
import Blog from "../pages/Blog";
import Car from "~/pages/Car/Car";
// import Rank from "../pages/Cars copy";
export const publicRoutes = [
    { path: "/", component: Home },
    { path: "/brands/*", component: Cars },
    { path: "/blog", component: Blog },
    { path: "/car", component: Car },
    // { path: "/rank", component: Rank },
];
export const Routers = {
    home: "/",
    cars: "/brands",
    rank: "/car",
    blog: "/blog",
    detail: "/detail",
};
// export const RoutersBrands = [
//     {

//     }
// ];
